/* eslint react/prop-types: 0 */
import React, { Fragment } from "react";

import SearchBuildings from "../../../common/SearchBuildings";
import {
  getTranslatedValue,
  translateStatic,
} from "../../../helpers/translationHelper";
import * as theme1Styles from "../scss/theme1.module.scss";

class BuildingSearch extends SearchBuildings {
  constructor(props) {
    super(props);
  }

  render() {
    const { propertyTypes, locale, defaultLocale } = this.props;

    return (
      <Fragment>
        <div className={`${theme1Styles.searchColm}`}>
          <div className={`${theme1Styles.filterSearch}`}>
            <input
              type="text"
              className={theme1Styles.field}
              name="search"
              value={this.state.searchForm.search}
              onChange={this.handleInputChange}
            />
            <button
              className={theme1Styles.srch}
              onClick={() => this.searchBuildings()}
            ></button>
          </div>
        </div>
        <div className={`${theme1Styles.filterC}`}>
          <div className={`${theme1Styles.filterRow}`}>
            <div className={theme1Styles.colm}>
              <select
                className={theme1Styles.field}
                name="type"
                value={this.state.searchForm.type}
                onChange={this.handleInputChange}
              >
                <option value="">
                  {translateStatic("type", locale, defaultLocale)}
                </option>
                {(() => {
                  return propertyTypes.map((property_type) => {
                    return (
                      <option value={property_type.id} key={property_type.id}>
                        {getTranslatedValue(
                          property_type.translations,
                          "name",
                          locale,
                          defaultLocale
                        )}
                      </option>
                    );
                  });
                })()}
              </select>
            </div>
          </div>
          <div className={`${theme1Styles.filterBtns}`}>
            <button
              className={`${theme1Styles.btn} ${theme1Styles.btnSm} ${theme1Styles.propSrchBtn}`}
              onClick={() => this.searchBuildings()}
            >
              {translateStatic("filter", locale, defaultLocale)}
            </button>
            <button
              className={`${theme1Styles.btn} ${theme1Styles.btnSm}`}
              onClick={() => this.clearSearchForm()}
            >
              {translateStatic("clear", locale, defaultLocale)}
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default BuildingSearch;
